import { Box } from "@outschool/backpack";
import {
  ClassDetailsNav,
  MobileActivityHeader,
  MobileActivityPrice,
  useMobileCDPGroupExperiment
} from "@outschool/ui-components-website";
import { Container, Modal } from "@outschool/ui-legacy-component-library";
import React from "react";

import ActivityDetailDescription from "../sections/ActivityDetailDescription";
import LearningGoals from "../sections/LearningGoals";
import OtherDetails from "../sections/OtherDetails";
import SyllabusSummary from "../sections/SyllabusSummary";
import WhatsIncluded from "../sections/WhatsIncluded";
import {
  MobileClassDetailsMainBodyProps,
  gradientFadeStyle
} from "./Components";
import { ReviewsSection } from "./Reviews";

export default function MobileClassDetailsMainBody({
  // props
  activity,
  canEnroll,
  classNavTabs,
  facebookAppId,
  hasOneOnOneAvailabilities,
  isAvailabilityModalOpen,
  isLoadingOneOnOneAvailabilities,
  leader,
  onClickViewReviews,
  setIsAvailabilityModalOpen,
  setTabValue,
  showAvailableTimes,
  tabValue,
  // refs
  refsContainer,
  sectionsRef,
  // memos & elements
  ActivityEnrollableTimes,
  AskAQuestionButton,
  AvailableTimes,
  BecomeAMemberBanner,
  MessageModal,
  ReviewRespondButton,
  SeeScheduleButtonMemo,
  TeacherSection
}: MobileClassDetailsMainBodyProps) {
  const enableMobileCDPGroup1Exp = useMobileCDPGroupExperiment();
  return (
    <>
      <Box
        ref={refsContainer.about.header}
        flex
        sx={{ flexDirection: "column" }}
      >
        <MobileActivityHeader
          activity={activity}
          leader={leader}
          onClickViewReviews={onClickViewReviews}
          facebookAppId={facebookAppId}
          MessageTeacherButton={AskAQuestionButton}
          BecomeAMemberBanner={BecomeAMemberBanner}
        />
      </Box>
      {showAvailableTimes && (
        <Container ref={sectionsRef} sx={{ marginTop: "2em" }}>
          {AvailableTimes}
        </Container>
      )}
      <Modal
        stickyHeader
        open={!!isAvailabilityModalOpen}
        onClose={() =>
          !!setIsAvailabilityModalOpen && setIsAvailabilityModalOpen(false)
        }
        sx={{ padding: "1.25em" }}
      >
        {((hasOneOnOneAvailabilities ||
          (activity.hasTeacherSchedule && isLoadingOneOnOneAvailabilities)) &&
          canEnroll &&
          ActivityEnrollableTimes) ||
          AvailableTimes}
      </Modal>
      {enableMobileCDPGroup1Exp && (
        <Box
          flex
          sx={{
            paddingTop: "1.25em",
            paddingX: "1em",
            justifyContent: "space-between"
          }}
        >
          <MobileActivityPrice activity={activity} />
          <Box flex>{SeeScheduleButtonMemo}</Box>
        </Box>
      )}
      <ClassDetailsNav tabs={classNavTabs ?? []} />
      <Box
        flex
        sx={{
          marginTop: "6.4rem",
          flexDirection: "column",
          gap: "8rem",
          marginX: 16
        }}
      >
        <WhatsIncluded
          activity={activity}
          headerRef={refsContainer.about.whatsIncluded}
        />
        <ActivityDetailDescription
          activity={activity}
          MessageModal={MessageModal}
          headerRef={refsContainer.about.classExperience}
          gradientStyles={gradientFadeStyle}
        />
        <LearningGoals
          learningGoals={activity.learningGoals}
          headerRef={refsContainer.learningOverview.learningGoals}
        />
        <SyllabusSummary
          activity={activity}
          headerRef={refsContainer.learningOverview.syllabus}
        />
        <OtherDetails
          activity={activity}
          headerRef={refsContainer.learningOverview.otherDetails}
        />
        {TeacherSection}
        {!!tabValue && !!setTabValue && (
          <ReviewsSection
            activity={activity}
            reviewsRef={refsContainer.reviews}
            setTabValue={setTabValue}
            tabValue={tabValue}
            ReviewRespondButton={ReviewRespondButton}
          />
        )}
      </Box>
    </>
  );
}
